enum LoadUnavailableIndicatorType {
  None = 'none',
  Overlay = 'overlay',
}

export default LoadUnavailableIndicatorType;
